import { VersionType } from "./constants";

interface BookOption {
  simplified: string;
  traditional: string;
  english: string;
  simAbbrev: string;
  triAbbrev: string;
  engAbbrev: string;
  maxChapter: number;
};

export interface SelectorOption {
  label: string;
  value: string;
};

export const generateOptions = (versions: VersionType[]): SelectorOption[] => {
  let options: SelectorOption[] = [];
  const isTraditional = versions.includes(VersionType.ZHTW);
  booksOfTheBible.forEach(book => {
    options.push({
      label:  isTraditional ? book.traditional : book.simplified,
      value: isTraditional ? book.traditional : book.simplified
    });
    options.push({
      label: book.english,
      value: book.english
    });
  });
  return options;
};

export const matchesBookName = (bookObj: BookOption, book: string): boolean => {
  return bookObj.simplified === book ||
         bookObj.traditional === book ||
         bookObj.english === book ||
         bookObj.simAbbrev === book ||
         bookObj.triAbbrev === book ||
         bookObj.engAbbrev === book;
};

export const booksOfTheBible: BookOption[] = [
  {
    simplified: "创世记",
    simAbbrev: "创",
    traditional: "創世記",
    triAbbrev: "創",
    english: "Genesis",
    engAbbrev: "Gen",
    maxChapter: 50
  },
  {
    simplified: "出埃及记",
    simAbbrev: "出",
    traditional: "出埃及記",
    triAbbrev: "出",
    english: "Exodus",
    engAbbrev: "Exo",
    maxChapter: 40,
  },
  {
    simplified: "利未记",
    simAbbrev: "利",
    traditional: "利未記",
    triAbbrev: "利",
    english: "Leviticus",
    engAbbrev: "Lev",
    maxChapter: 27,
  },
  {
    simplified: "民数记",
    simAbbrev: "民",
    traditional: "民數記",
    triAbbrev: "民",
    english: "Numbers",
    engAbbrev: "Num",
    maxChapter: 36,
  },
  {
    simplified: "申命记",
    simAbbrev: "申",
    traditional: "申命記",
    triAbbrev: "申",
    english: "Deuteronomy",
    engAbbrev: "Deu",
    maxChapter: 34,
  },
  {
    simplified: "约书亚记",
    simAbbrev: "书",
    traditional: "約書亞記",
    triAbbrev: "書",
    english: "Joshua",
    engAbbrev: "Jos",
    maxChapter: 24,
  },
  {
    simplified: "士师记",
    simAbbrev: "士",
    traditional: "士師記",
    triAbbrev: "士",
    english: "Judges",
    engAbbrev: "Jug",
    maxChapter: 21,
  },
  {
    simplified: "路得记",
    simAbbrev: "得",
    traditional: "路得記",
    triAbbrev: "得",
    english: "Ruth",
    engAbbrev: "Rut",
    maxChapter: 4,
  },
  {
    simplified: "撒母耳记上",
    simAbbrev: "撒上",
    traditional: "撒母耳記上",
    triAbbrev: "撒上",
    english: "1_Samuel",
    engAbbrev: "1Sa",
    maxChapter: 31,
  },
  {
    simplified: "撒母耳记下",
    simAbbrev: "撒下",
    traditional: "撒母耳記下",
    triAbbrev: "撒下",
    english: "2_Samuel",
    engAbbrev: "2Sa",
    maxChapter: 24,
  },
  {
    simplified: "列王纪上",
    simAbbrev: "王上",
    traditional: "列王紀上",
    triAbbrev: "王上",
    english: "1_Kings",
    engAbbrev: "1Ki",
    maxChapter: 22,
  },
  {
    simplified: "列王纪下",
    simAbbrev: "王下",
    traditional: "列王紀下",
    triAbbrev: "王下",
    english: "2_Kings",
    engAbbrev: "2Ki",
    maxChapter: 25,
  },
  {
    simplified: "历代志上",
    simAbbrev: "代上",
    traditional: "歷代志上",
    triAbbrev: "代上",
    english: "1_Chronicles",
    engAbbrev: "1Ch",
    maxChapter: 29,
  },
  {
    simplified: "历代志下",
    simAbbrev: "代下",
    traditional: "歷代志下",
    triAbbrev: "代下",
    english: "2_Chronicles",
    engAbbrev: "2Ch",
    maxChapter: 36,
  },
  {
    simplified: "以斯拉记",
    simAbbrev: "拉",
    traditional: "以斯拉記",
    triAbbrev: "拉",
    english: "Ezra",
    engAbbrev: "Ezr",
    maxChapter: 10,
  },
  {
    simplified: "尼希米记",
    simAbbrev: "尼",
    traditional: "尼希米記",
    triAbbrev: "尼",
    english: "Nehemiah",
    engAbbrev: "Neh",
    maxChapter: 13,
  },
  {
    simplified: "以斯帖记",
    simAbbrev: "斯",
    traditional: "以斯帖記",
    triAbbrev: "斯",
    english: "Esther",
    engAbbrev: "Est",
    maxChapter: 10,
  },
  {
    simplified: "约伯记",
    simAbbrev: "伯",
    traditional: "約伯記",
    triAbbrev: "伯",
    english: "Job",
    engAbbrev: "Job",
    maxChapter: 42,
  },
  {
    simplified: "诗篇",
    simAbbrev: "诗",
    traditional: "詩篇",
    triAbbrev: "詩",
    english: "Psalms",
    engAbbrev: "Psm",
    maxChapter: 150,
  },
  {
    simplified: "箴言",
    simAbbrev: "箴",
    traditional: "箴言",
    triAbbrev: "箴",
    english: "Proverbs",
    engAbbrev: "Pro",
    maxChapter: 31,
  },
  {
    simplified: "传道书",
    simAbbrev: "传",
    traditional: "傳道書",
    triAbbrev: "傳",
    english: "Ecclesiastes",
    engAbbrev: "Ecc",
    maxChapter: 12,
  },
  {
    simplified: "雅歌",
    simAbbrev: "歌",
    traditional: "雅歌",
    triAbbrev: "歌",
    english: "Song_of_Songs",
    engAbbrev: "Son",
    maxChapter: 8,
  },
  {
    simplified: "以赛亚书",
    simAbbrev: "赛",
    traditional: "以賽亞書",
    triAbbrev: "賽",
    english: "Isaiah",
    engAbbrev: "Isa",
    maxChapter: 66,
  },
  {
    simplified: "耶利米书",
    simAbbrev: "耶",
    traditional: "耶利米書",
    triAbbrev: "耶",
    english: "Jeremiah",
    engAbbrev: "Jer",
    maxChapter: 52,
  },
  {
    simplified: "耶利米哀歌",
    simAbbrev: "哀",
    traditional: "耶利米哀歌",
    triAbbrev: "哀",
    english: "Lamentations",
    engAbbrev: "Lam",
    maxChapter: 5,
  },
  {
    simplified: "以西结书",
    simAbbrev: "结",
    traditional: "以西結書",
    triAbbrev: "結",
    english: "Ezekiel",
    engAbbrev: "Eze",
    maxChapter: 48,
  },
  {
    simplified: "但以理书",
    simAbbrev: "但",
    traditional: "但以理書",
    triAbbrev: "但",
    english: "Daniel",
    engAbbrev: "Dan",
    maxChapter: 12,
  },
  {
    simplified: "何西阿书",
    simAbbrev: "何",
    traditional: "何西阿書",
    triAbbrev: "何",
    english: "Hosea",
    engAbbrev: "Hos",
    maxChapter: 14,
  },
  {
    simplified: "约珥书",
    simAbbrev: "珥",
    traditional: "約珥書",
    triAbbrev: "珥",
    english: "Joel",
    engAbbrev: "Joe",
    maxChapter: 3,
  },
  {
    simplified: "阿摩司书",
    simAbbrev: "摩",
    traditional: "阿摩司書",
    triAbbrev: "摩",
    english: "Amos",
    engAbbrev: "Amo",
    maxChapter: 9,
  },
  {
    simplified: "俄巴底亚书",
    simAbbrev: "俄",
    traditional: "俄巴底亞書",
    triAbbrev: "俄",
    english: "Obadiah",
    engAbbrev: "Oba",
    maxChapter: 1,
  },
  {
    simplified: "约拿书",
    simAbbrev: "拿",
    traditional: "約拿書",
    triAbbrev: "拿",
    english: "Jonah",
    engAbbrev: "Jon",
    maxChapter: 4,
  },
  {
    simplified: "弥迦书",
    simAbbrev: "弥",
    traditional: "彌迦書",
    triAbbrev: "彌",
    english: "Micah",
    engAbbrev: "Mic",
    maxChapter: 7,
  },
  {
    simplified: "那鸿书",
    simAbbrev: "鸿",
    traditional: "那鴻書",
    triAbbrev: "鴻",
    english: "Nahum",
    engAbbrev: "Nah",
    maxChapter: 3,
  },
  {
    simplified: "哈巴谷书",
    simAbbrev: "哈",
    traditional: "哈巴谷書",
    triAbbrev: "哈",
    english: "Habakkuk",
    engAbbrev: "Hab",
    maxChapter: 3,
  },
  {
    simplified: "西番雅书",
    simAbbrev: "番",
    traditional: "西番雅書",
    triAbbrev: "番",
    english: "Zephaniah",
    engAbbrev: "Zep",
    maxChapter: 3,
  },
  {
    simplified: "哈该书",
    simAbbrev: "该",
    traditional: "哈該書",
    triAbbrev: "該",
    english: "Haggai",
    engAbbrev: "Hag",
    maxChapter: 2,
  },
  {
    simplified: "撒迦利亚书",
    simAbbrev: "亚",
    traditional: "撒迦利亞書",
    triAbbrev: "亞",
    english: "Zechariah",
    engAbbrev: "Zec",
    maxChapter: 14,
  },
  {
    simplified: "玛拉基书",
    simAbbrev: "玛",
    traditional: "瑪拉基書",
    triAbbrev: "瑪",
    english: "Malachi",
    engAbbrev: "Mal",
    maxChapter: 4,
  },
  {
    simplified: "马太福音",
    simAbbrev: "太",
    traditional: "馬太福音",
    triAbbrev: "太",
    english: "Matthew",
    engAbbrev: "Mat",
    maxChapter: 28,
  },
  {
    simplified: "马可福音",
    simAbbrev: "可",
    traditional: "馬可福音",
    triAbbrev: "可",
    english: "Mark",
    engAbbrev: "Mak",
    maxChapter: 16,
  },
  {
    simplified: "路加福音",
    simAbbrev: "路",
    traditional: "路加福音",
    triAbbrev: "路",
    english: "Luke",
    engAbbrev: "Luk",
    maxChapter: 24,
  },
  {
    simplified: "约翰福音",
    simAbbrev: "约",
    traditional: "約翰福音",
    triAbbrev: "約",
    english: "John",
    engAbbrev: "Jhn",
    maxChapter: 21,
  },
  {
    simplified: "使徒行传",
    simAbbrev: "徒",
    traditional: "使徒行傳",
    triAbbrev: "徒",
    english: "Acts",
    engAbbrev: "Act",
    maxChapter: 28,
  },
  {
    simplified: "罗马书",
    simAbbrev: "罗",
    traditional: "羅馬書",
    triAbbrev: "羅",
    english: "Romans",
    engAbbrev: "Rom",
    maxChapter: 16,
  },
  {
    simplified: "哥林多前书",
    simAbbrev: "林前",
    traditional: "哥林多前書",
    triAbbrev: "林前",
    english: "1_Corinthians",
    engAbbrev: "1Co",
    maxChapter: 16,
  },
  {
    simplified: "哥林多后书",
    simAbbrev: "林后",
    traditional: "哥林多後書",
    triAbbrev: "林後",
    english: "2_Corinthians",
    engAbbrev: "2Co",
    maxChapter: 13,
  },
  {
    simplified: "加拉太书",
    simAbbrev: "加",
    traditional: "加拉太書",
    triAbbrev: "加",
    english: "Galatians",
    engAbbrev: "Gal",
    maxChapter: 6,
  },
  {
    simplified: "以弗所书",
    simAbbrev: "弗",
    traditional: "以弗所書",
    triAbbrev: "弗",
    english: "Ephesians",
    engAbbrev: "Eph",
    maxChapter: 6,
  },
  {
    simplified: "腓立比书",
    simAbbrev: "腓",
    traditional: "腓立比書",
    triAbbrev: "腓",
    english: "Philippians",
    engAbbrev: "Phl",
    maxChapter: 4,
  },
  {
    simplified: "歌罗西书",
    simAbbrev: "西",
    traditional: "歌羅西書",
    triAbbrev: "西",
    english: "Colossians",
    engAbbrev: "Col",
    maxChapter: 4,
  },
  {
    simplified: "帖撒罗尼迦前书",
    simAbbrev: "帖前",
    traditional: "帖撒羅尼迦前書",
    triAbbrev: "帖前",
    english: "1_Thessalonians",
    engAbbrev: "1Ts",
    maxChapter: 5,
  },
  {
    simplified: "帖撒罗尼迦后书",
    simAbbrev: "帖后",
    traditional: "帖撒羅尼迦後書",
    triAbbrev: "帖後",
    english: "2_Thessalonians",
    engAbbrev: "2Ts",
    maxChapter: 3,
  },
  {
    simplified: "提摩太前书",
    simAbbrev: "提前",
    traditional: "提摩太前書",
    triAbbrev: "提前",
    english: "1_Timothy",
    engAbbrev: "1Ti",
    maxChapter: 6,
  },
  {
    simplified: "提摩太后书",
    simAbbrev: "提后",
    traditional: "提摩太後書",
    triAbbrev: "提後",
    english: "2_Timothy",
    engAbbrev: "2Ti",
    maxChapter: 4,
  },
  {
    simplified: "提多书",
    simAbbrev: "多",
    traditional: "提多書",
    triAbbrev: "多",
    english: "Titus",
    engAbbrev: "Tit",
    maxChapter: 3,

  },
  {
    simplified: "腓利门书",
    simAbbrev: "门",
    traditional: "腓利門書",
    triAbbrev: "門",
    english: "Philemon",
    engAbbrev: "Phm",
    maxChapter: 1,
  },
  {
    simplified: "希伯来书",
    simAbbrev: "來",
    traditional: "希伯來書",
    triAbbrev: "來",
    english: "Hebrews",
    engAbbrev: "Heb",
    maxChapter: 13,
  },
  {
    simplified: "雅各书",
    simAbbrev: "雅",
    traditional: "雅各書",
    triAbbrev: "雅",
    english: "James",
    engAbbrev: "Jas",
    maxChapter: 5,
  },
  {
    simplified: "彼得前书",
    simAbbrev: "彼前",
    traditional: "彼得前書",
    triAbbrev: "彼前",
    english: "1_Peter",
    engAbbrev: "1Pe",
    maxChapter: 5,
  },
  {
    simplified: "彼得后书",
    simAbbrev: "彼后",
    traditional: "彼得後書",
    triAbbrev: "彼後",
    english: "2_Peter",
    engAbbrev: "2Pe",
    maxChapter: 3,
  },
  {
    simplified: "约翰一书",
    simAbbrev: "约一",
    traditional: "約翰一書",
    triAbbrev: "約一",
    english: "1_John",
    engAbbrev: "1Jn",
    maxChapter: 5,
  },
  {
    simplified: "约翰二书",
    simAbbrev: "约二",
    traditional: "約翰二書",
    triAbbrev: "約二",
    english: "2_John",
    engAbbrev: "2Jn",
    maxChapter: 1,
  },
  {
    simplified: "约翰三书",
    simAbbrev: "约三",
    traditional: "約翰三書",
    triAbbrev: "約三",
    english: "3_John",
    engAbbrev: "3Jn",
    maxChapter: 1,
  },
  {
    simplified: "犹大书",
    simAbbrev: "犹",
    traditional: "猶大書",
    triAbbrev: "猶",
    english: "Jude",
    engAbbrev: "Jud",
    maxChapter: 1,
  },
  {
    simplified: "启示录",
    simAbbrev: "启",
    traditional: "啟示錄",
    triAbbrev: "啟",
    english: "Revelation",
    engAbbrev: "Rev",
    maxChapter: 22,
  }
]




  